import { render, staticRenderFns } from "./ReintegrerExpedition.vue?vue&type=template&id=4f132229&"
import script from "./ReintegrerExpedition.vue?vue&type=script&lang=js&"
export * from "./ReintegrerExpedition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports